import * as ng from 'angular';

export class AtomRequiredComponent implements ng.IComponentOptions {
    public template = require('./required.html');
}
